import { Crown, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const openUpgrade = () => window.dispatchEvent(new CustomEvent("open-upgrade"));

export const UpgradeCTA = ({ plan, text, testid }) => {
  const { user } = useAuth();
  const isOwner = user?.role === "owner";
  return (
    <div className="rounded-md border border-gold/40 bg-accent/60 px-3 py-3 text-xs text-ink flex flex-col sm:flex-row sm:items-center gap-3" data-testid={testid}>
      <Crown className="w-5 h-5 text-gold shrink-0" />
      <p className="flex-1">
        {text} Disponível a partir do plano <strong>{plan}</strong>.
        {!isOwner && " Peça ao responsável pela clínica para fazer o upgrade."}
      </p>
      {isOwner && (
        <button type="button" onClick={openUpgrade} data-testid={`${testid}-button`}
          className="group inline-flex items-center justify-center gap-1.5 rounded-md bg-gold hover:bg-gold-hover text-ink font-semibold px-4 py-2 text-xs transition-colors shrink-0">
          Fazer upgrade <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
        </button>
      )}
    </div>
  );
};
